<template>
  <q-page padding>
    <div class="row col-12">
      <p class="text-h6 text-brand-5 text-weight-bold">Papéis e permissões</p>
    </div>

    <section class="row">
      <div class="col-md-3 col-2 q-mt-sm">
        <q-input dense outlined label="Nome" v-model="nome" />
      </div>

      <div style="margin-top: 11px" class="q-ml-sm">
        <q-btn
          @click="criarRole"
          color="positive"
          label="Criar Papel"
          dense
          no-caps
          icon="add"
          class="q-ml-sm"
        />
      </div>
    </section>

    <div style="margin-top: 45px">
      <p class="text-h6 text-brand-5 text-weight-bold">
        Papéis (selecione para ver as permissões associadas)
      </p>
      <div style="width: 385px" class="q-mt-sm q-mb-md">
        <q-select
          outlined
          dense
          v-model="selected"
          :options="rows"
          option-label="name"
          option-value="id"
          label="Selecione um papel"
          @update:model-value="
            (value) => {
              if (value) {
                getPermisao(value.id, false);
                lastIdSelected = value.id;
              }
            }
          "
        />
      </div>
    </div>

    <div class="q-pt-md">
      <q-table
        flat
        table-header-class="bg-accent text-width-bold"
        :filter="filter"
        dense
        title="Adicionar/Remover Permissões"
        :rows="rows2"
        :columns="columns2"
        class="tabela-tamanho-fixo"
        :loading="disable"
        v-model:pagination="pagination"
        hide-pagination
        :rows-per-page-options="[0]"
      >
        <template v-slot:top-right>
          <div style="display: flex; align-items: center">
            <q-btn
              label="Adicionar Todas"
              icon="done"
              color="positive"
              class="q-mr-sm"
              no-caps
              @click="ativarTodas"
            />
            <q-btn
              label="Remover Todas"
              icon="close"
              color="negative"
              class="q-mr-sm"
              no-caps
              @click="removerTodas"
            />
            <q-input
              rounded
              outlined
              dense
              v-model="nomePermissao"
              debounce="300"
              type="text"
              placeholder="Pesquisar"
            >
              <template v-slot:append>
                <q-icon name="search" />
              </template>
            </q-input>
          </div>
        </template>
        <template #body-cell-ativar="props">
          <q-td>
            <q-toggle
              v-model="value"
              :val="props.row.id"
              color="primary"
              @click="ativar(props.row.id, $event)"
            />
          </q-td>
        </template>
      </q-table>
      <div class="row justify-start q-mt-md">
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          size="sm"
        />
        <div class="col-md-1 q-ml-sm col-2 q-mt-sm">
          <q-select
            v-model="pagination.rowsPerPage"
            :options="listaPaginas"
            dense
            label="Linhas por pagina"
            borderless
          />
        </div>
      </div>
    </div>
  </q-page>
</template>

<script>
const columns = [
  {
    name: "name",
    label: "Nome",
    field: "name",
    align: "left",
  },
];

const columns2 = [
  {
    name: "ativar",
    label: "Desativar / Ativar",
    field: "ativar",
    align: "left",
  },
  {
    name: "description",
    label: "Permissão",
    field: "description",
    align: "left",
  },
];

import { ref, computed, onMounted, watch } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
export default {
  setup() {
    const store = useStore();
    const rows = ref([]);
    const rows2 = ref([]);
    const disable = ref(true);
    const selected = ref([]);
    const value = ref([]);
    const $q = useQuasar();
    const nome = ref("");
    const lastIdSelected = ref(null);
    const filter = ref("");
    const nomePermissao = ref("");
    const pesquisarTopo = ref("");
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 15,
      rowsNumber: 15,
    });

    const pagination2 = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 8,
      rowsNumber: 8,
    });

    const getRoles = async (page = 1, rowsPerPage = 1000) => {
      const response = await store.dispatch("adminMultpex/getRoles", {
        search: pesquisarTopo.value,
        per_page: rowsPerPage,
        page: page,
      });

      rows.value = response.data.results.data;
      pagination2.value.rowsPerPage = response.data.results.per_page;
      pagination2.value.rowsNumber = response.data.results.total;
      pagination2.value.page = response.data.results.current_page;
      disable.value = false;
    };

    onMounted(getRoles);

    const getPermisao = async (
      idValue,
      filterPermissions,
      page = 1,
      rowsPerPage = 15
    ) => {
      disable.value = true;

      if (!filterPermissions) {
        value.value = [];

        const responsePerson = await store.dispatch(
          "adminMultpex/getRolesPerson",
          {
            id: idValue != undefined ? idValue : lastIdSelected.value,
          }
        );
        responsePerson.data.model.permissions.forEach((e) => {
          value.value.push(e.id);
        });
      }

      const response = await store.dispatch("adminMultpex/getPermissao", {
        nome: nomePermissao.value,
        per_page: rowsPerPage,
        page: page,
      });

      rows2.value = response.data.results.data;
      pagination.value.rowsPerPage = response.data.results.per_page;
      pagination.value.rowsNumber = response.data.results.total;
      pagination.value.page = response.data.results.current_page;
      disable.value = false;
    };

    const ativar = async (id, event) => {
      try {
        if (event.currentTarget.ariaChecked == "false") {
          await store.dispatch("adminMultpex/ativarPermissao", {
            permission_ids: [id],
            role_id: selected.value?.id,
          });
          $q.notify({
            message: "Atualizado com sucesso",
            color: "positive",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        } else if (event.currentTarget.ariaChecked == "true") {
          await store.dispatch("adminMultpex/desativarPermissao", {
            permission_ids: [id],
            role_id: selected.value?.id,
          });

          $q.notify({
            message: "Atualizado com sucesso",
            color: "positive",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
        getRoles();
      } catch (error) {
        getRoles();
        $q.notify({
          message: "Erro a o configurar permissao",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const ativarTodas = async () => {
      rows2.value.forEach(async (value) => {
        try {
          await store.dispatch("adminMultpex/ativarPermissao", {
            permission_ids: [value.id],
            role_id: selected.value?.id,
          });
          $q.notify({
            message: "Ativação geral realizado com sucesso",
            color: "positive",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        } catch (error) {
          $q.notify({
            message: "Erro na ativação geral",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      });
      setTimeout(async () => {
        value.value = [];
        await getRoles();
        await getPermisao(
          lastIdSelected.value,
          false,
          pagination.value.page,
          pagination.value.rowsPerPage
        );
      }, 2000);
    };

    const removerTodas = async () => {
      rows2.value.forEach(async (value) => {
        try {
          await store.dispatch("adminMultpex/desativarPermissao", {
            permission_ids: [value.id],
            role_id: selected.value?.id,
          });
          $q.notify({
            message: "Desativação geral realizado com sucesso",
            color: "positive",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        } catch (error) {
          $q.notify({
            message: "Erro na Desativação geral",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      });
      setTimeout(async () => {
        value.value = [];
        await getRoles();
        await getPermisao(
          lastIdSelected.value,
          false,
          pagination.value.page,
          pagination.value.rowsPerPage
        );
      }, 2000);
    };

    const criarRole = async () => {
      try {
        await store.dispatch("adminMultpex/criarRole", {
          description: nome.value,
          display_name: nome.value,
        });
        $q.notify({
          message: "Role criada com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        $q.notify({
          message: "Erro a o criar Role",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    nomePermissao;

    watch(
      () => nomePermissao.value,
      () => {
        getPermisao(
          undefined,
          true,
          pagination.value.page,
          pagination.value.rowsPerPage
        );
      }
    );

    watch(
      () => pesquisarTopo.value,
      () => {
        getRoles();
      }
    );

    const handleRequest = async () => {
      getPermisao(
        undefined,
        true,
        pagination.value.page,
        pagination.value.rowsPerPage
      );
    };

    watch(
      () => pagination.value.page,
      () => {
        disable.value = true;
        handleRequest();
      }
    );

    watch(
      () => pagination2.value.page,
      () => {
        disable.value = true;
        getRoles(pagination2.value.page, pagination2.value.rowsPerPage);
      }
    );

    watch(
      () => pagination.value.rowsPerPage,
      () => {
        disable.value = true;
        (pagination.value.page = 1), handleRequest();
      }
    );

    return {
      pagination,
      rows,
      rows2,
      disable,
      columns,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      pagesNumber2: computed(() =>
        Math.ceil(pagination2.value.rowsNumber / pagination2.value.rowsPerPage)
      ),
      selected,
      getPermisao,
      columns2,
      ativar,
      value,
      criarRole,
      nome,
      filter,
      nomePermissao,
      ativarTodas,
      removerTodas,
      pesquisarTopo,
      lastIdSelected,
      listaPaginas: [10, 25, 50, 100, 200, 300],
      pagination2,
    };
  },
};
</script>
